module.exports = __webpack_public_path__ + "img/bank_15.3721f085.png";